var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// - Impoer react components
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import GridList from '@material-ui/core/GridList';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import GridListTile from '@material-ui/core/GridListTile';
import Button from '@material-ui/core/Button';
import SvgAddImage from '@material-ui/icons/AddAPhoto';
import SvgDelete from '@material-ui/icons/Delete';
import { withStyles } from '@material-ui/core/styles';
import uuid from 'uuid';
import { getTranslate } from 'react-localize-redux';
// - Import actions
import * as imageGalleryActions from 'store/actions/imageGalleryActions';
import * as globalActions from 'store/actions/globalActions';
import Img3 from 'components/img3';
// - Import API
import FileAPI from 'api/FileAPI';
var styles = function (theme) {
    var _a;
    return ({
        fullPageXs: (_a = {},
            _a[theme.breakpoints.down('xs')] = {
                width: '100%',
                height: '100%',
                margin: 0,
                overflowY: 'auto'
            },
            _a)
    });
};
/**
 * Create ImageGallery component class
 */
var ImageGalleryComponent = /** @class */ (function (_super) {
    __extends(ImageGalleryComponent, _super);
    /**
     * Component constructor
     * @param  {object} props is an object properties of component
     */
    function ImageGalleryComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.styles = {
            root: {
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-around'
            },
            gridList: {
                width: 500,
                height: 450,
                overflowY: 'auto'
            },
            uploadButton: {
                verticalAlign: 'middle',
                fontWeight: 400,
                color: 'red'
            },
            uploadInput: {
                cursor: 'pointer',
                position: 'absolute',
                top: 0,
                bottom: 0,
                right: 0,
                left: 0,
                width: '100%',
                opacity: 0
            },
            deleteImage: {
                marginLeft: '5px',
                cursor: 'pointer',
                color: 'white'
            },
            addImage: {
                marginRight: '5px',
                cursor: 'pointer',
                color: 'white'
            }
        };
        /**
         * Handle set image
         * @param  {event} evt  passed by on click event on add image
         * @param  {string} name is the name of the image
         */
        _this.handleSetImage = function (event, URL, fullPath, imageArr) {
            // alert('set')
            _this.props.set(URL, fullPath, imageArr);
            _this.close();
        };
        /**
         * Handle delete image
         * @param  {event} evt  passed by on click event on delete image
         * @param  {integer} id is the image identifier which selected to delete
         */
        _this.handleDeleteImage = function (event, id) {
            _this.props.deleteImage(id);
        };
        /**
         * Handle send image resize event that pass the resized image
         *
         *
         * @memberof ImageGallery
         */
        _this.handleSendResizedImage = function (event) {
            // console.log('single', event.detail)
            // const { resizedImage, fileName } = event.detail
            // const {uploadImage} = this.props
            // uploadImage!(resizedImage,fileName)
        };
        _this.handleSendResizedImageArr = function (event) {
            event.detail.resizedArr.forEach(function (file) {
                console.warn('file', file);
            });
            var uploadImages = _this.props.uploadImages;
            uploadImages(event.detail.resizedArr);
        };
        _this.handleSend3dImg = function (event) {
            var _a = event.detail, thisfile = _a.thisfile, fileName = _a.fileName;
            var uploadImage = _this.props.uploadImage;
            uploadImage(thisfile, fileName);
        };
        /**
         * Handle on change file upload
         */
        _this.onFileChange = function (event) {
            console.warn(1);
            var arr = Array.from(event.target.files);
            var ResArr = new Array();
            arr.forEach(function (file) {
                var extension = FileAPI.getExtension(file.name);
                var fileName = (uuid() + "." + extension);
                var image2 = FileAPI.constraintImage(file, fileName);
                var image = FileAPI.img3Load(file, fileName);
            });
            var image1 = FileAPI.constraintImage1(arr, ResArr);
        };
        /**
         * Hide image gallery
         */
        _this.close = function () {
            _this.props.close();
        };
        _this.imageList = function () {
            return _this.props.images.map(function (image, index) {
                return (React.createElement(GridListTile, { key: image.id },
                    React.createElement("div", null,
                        React.createElement("div", { style: { overflowY: 'hidden', overflowX: 'auto' } },
                            React.createElement("ul", { style: { whiteSpace: 'nowrap', padding: '0 6px', margin: '8px 0 0 0', verticalAlign: 'bottom', flexShrink: 0, listStyleType: 'none' } },
                                React.createElement("div", { style: { display: 'block' } },
                                    React.createElement("div", { style: { display: 'block', marginRight: '8px', transition: 'transform .25s' } },
                                        React.createElement("li", { style: { width: '100%', margin: 0, verticalAlign: 'bottom', position: 'static', display: 'inline-block' } },
                                            React.createElement(Img3, { model: image.URL }))))))),
                    React.createElement(GridListTileBar, { title: React.createElement(SvgDelete, { style: _this.styles.deleteImage, onClick: function (evt) { return _this.handleDeleteImage(evt, image.id); } }), titlePosition: 'top', actionIcon: 
                        // <div onClick={evt => this.handleSetImage(evt, image.URL,image.fullPath, image.imageArr!)}> Post </div>}
                        React.createElement(SvgAddImage, { style: _this.styles.addImage, onClick: function (evt) { return _this.handleSetImage(evt, image.URL, image.fullPath, image.imageArr); } }), actionPosition: 'left' })));
            });
        };
        // Binding function to `this`
        _this.close = _this.close.bind(_this);
        _this.onFileChange = _this.onFileChange.bind(_this);
        _this.handleSetImage = _this.handleSetImage.bind(_this);
        _this.handleDeleteImage = _this.handleDeleteImage.bind(_this);
        _this.imageList = _this.imageList.bind(_this);
        return _this;
    }
    ImageGalleryComponent.prototype.componentDidMount = function () {
        window.addEventListener('onSendResizedImage', this.handleSendResizedImage);
        window.addEventListener('onSendResizedImageArr', this.handleSendResizedImageArr);
        window.addEventListener('3dImgUpload', this.handleSend3dImg);
    };
    ImageGalleryComponent.prototype.componentWillUnmount = function () {
        window.removeEventListener('onSendResizedImage', this.handleSendResizedImage);
    };
    ImageGalleryComponent.prototype.render = function () {
        var translate = this.props.translate;
        /**
         * Component styles
         * @type {Object}
         */
        return (React.createElement("div", { style: this.styles.root },
            React.createElement(GridList, { cellHeight: 180, style: this.styles.gridList },
                React.createElement(GridListTile, { key: 'upload-image-gallery' },
                    React.createElement("div", { style: { display: 'flex', backgroundColor: 'rgba(222, 222, 222, 0.52)', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%' } },
                        React.createElement("input", { 
                            // accept='image/*' 
                            style: this.styles.uploadInput, id: 'raised-button-file', onChange: this.onFileChange, type: 'file', multiple: true }),
                        React.createElement("label", { htmlFor: 'raised-button-file' },
                            React.createElement(Button
                            // variant='raised' 
                            , { 
                                // variant='raised' 
                                component: 'span', style: this.styles.uploadButton }, translate('imageGallery.uploadButton'))))),
                this.imageList())));
    };
    ImageGalleryComponent.propTypes = {
        /**
         * Callback function to ser image url on parent component
         */
        open: PropTypes.func
    };
    return ImageGalleryComponent;
}(Component));
export { ImageGalleryComponent };
/**
 * Map dispatch to props
 * @param  {func} dispatch is the function to dispatch action to reducers
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapDispatchToProps = function (dispatch, ownProps) {
    return {
        uploadImage: function (image, imageName) { return dispatch(imageGalleryActions.dbUploadImage(image, imageName)); },
        uploadImages: function (imageArr) { return dispatch(imageGalleryActions.dbUploadImages(imageArr)); },
        deleteImage: function (id) { return dispatch(imageGalleryActions.dbDeleteImage(id)); },
        progressChange: function (percent, status) { return dispatch(globalActions.progressChange(percent, status)); }
    };
};
/**
 * Map state to props
 * @param  {object} state is the obeject from redux store
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapStateToProps = function (state) {
    var uid = state.getIn(['authorize', 'uid']);
    var currentUser = state.getIn(['user', 'info', uid]);
    return {
        translate: getTranslate(state.get('locale')),
        images: state.getIn(['imageGallery', 'images']),
        avatar: currentUser ? currentUser.avatar : ''
    };
};
// - Connect component to redux store
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ImageGalleryComponent));



//////////////////
// WEBPACK FOOTER
// ./src/components/imageGallery/ImageGalleryComponent.tsx
// module id = 1266
// module chunks = 0 1 2 3 4 5 6 7